import { useEffect } from 'react';
import { Outlet } from '@tanstack/react-router';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { installAutoHideScrollbars } from '@/lib/auto-hide-scroll';
import { useUIStore } from '@/stores/ui-store';

export function AppShell() {
  const { mobileSidebarOpen, closeMobileSidebar } = useUIStore();

  // Scrollbar auto-hide global (aparece ao rolar, some ao parar).
  useEffect(() => installAutoHideScrollbars(), []);

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-bg pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]">
      {/* Backdrop mobile — fecha a sidebar ao clicar fora */}
      {mobileSidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/40 md:hidden"
          onClick={closeMobileSidebar}
          aria-hidden="true"
        />
      )}
      <Sidebar />
      <div className="flex flex-col flex-1 min-w-0">
        <Topbar />
        <main className="scroll-auto-hide flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
